<template>
  <div class="c-product-card">
    <div class="product-info">
      <div class="c-product-badge">
        <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>

        <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>

        <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="product-code">{{ item.matnr }}</div>
      <button
        type="button"
        class="product-name"
        @click="() => emit('select', item)"
      >
        <p>
          {{ item.zzmaktx }}
          <span v-if="item.qtyLack" style="color: red">
                    <!-- <br />(재고부족)가용량:{{ item.availability }}</span> -->
         <br />(재고부족)</span>
        </p>
      </button>
      <div class="info-bottom">
        <div class="c-counter">
          <button
            type="button"
            class="btn-minus"
            :disabled="item.quantity <= 1"
            @click="() => item.quantity--"
          >
            <i class="c-icon icon-minus size-xxsmall"></i>
            <span class="sr-only">빼기</span>
          </button>
          <input
            type="number"
            title="수량입력"
            min="1"
            v-model="item.quantity"
            ref="myInput"
            @mousedown="handleMouseDown"
          />
          <button type="button" class="btn-plus" @click="() => item.quantity++">
            <i class="c-icon icon-plus-black size-xxsmall"></i>
            <span class="sr-only">더하기</span>
          </button>
        </div>
        <p class="price">
          <strong class="system">{{
            Number(item.kbetr * item.quantity).toLocaleString()
          }}</strong
          >원
        </p>
      </div>
      <!-- 2024-12-16 삭제버튼 추가 -->
      <button
        type="button"
        class="btn-delete"
        @click="() => emit('delete', props.index)"
      >
        <i class="c-icon icon-small-x"></i>
        <span class="sr-only">상품 삭제</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from "vue";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
});
const emit = defineEmits(["select", "delete"]);

const item = ref(props.item);
const myInput = ref(null);

// 제품 수량 입력
watch(
  () => item.value.quantity,
  (newQty, oldQty) => {
    if (newQty < 1) {
      item.value.quantity = 1;
    } else if (newQty > 99999) {
      item.value.quantity = oldQty;
    } else {
      item.value.quantity = newQty;
    }
  }
);

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
